angular.module('ihestiaWidgets.policyDetails')
  .directive('ihestiaPolicyDetailsModalsInjector', [function() {
    return {
      controller: 'ihestiaPolicyDetailsModalsInjectorCtrl',
      restrict: 'E',
      scope: true,
      templateUrl: 'ihestia-widgets-templates-app/policyDetails/utils/modalsInjector/modalsInjector.tpl.html'
    };
  }]);
